module.exports = __webpack_public_path__ + "static/media/teen-burger-mb-sept-18_fr.efe6a317.jpg";